/* eslint-disable no-unused-vars, no-console */
import {
  getOGCustomer,
  getOGUpcomingOrders,
  sortOGOrders,
  getOGOrder,
  getOGSubscriptions,
} from '../subscription-modal/ordergroove-api-helper'

export default () => ({
  initialized: false,
  oneTimePrice: null,
  hideAddToAccount: false,
  requiresSellingPlan: false,
  variantId: null,
  discountEstimateObserver: null,
  init() {
    if (this.initialized) {
      return;
    }

    this.initialized = true;
    window.dsc = window.dsc || {};
    window.dsc.hideAddToAccount = false;
    this.updateVariantId();
    
    this.$nextTick(() => {
      this.updateUIOneTimePrice();
    });
    
    this.updateAddToAccountRestriction();
    this.requiresSellingPlan = this.$el.getAttribute('data-requires-selling-plan') === 'true';
    this.variantChangeWatcher();

    removeSellingPlanIdFromAddCartForm();
    removeAddToNextBoxFromAddCartForm();
    initializeOGAuth();
  },
  
  variantChangeWatcher() {
    const productSection = this.$el.closest('[id^="MainProduct-"], [id^="shopify-section-"]') || document;
    const discountEstimateContainer = productSection.querySelector('.discount-estimate');
    
    if (!discountEstimateContainer) {
      return;
    }

    let lastVariantId = discountEstimateContainer.getAttribute('data-variant-id');

    const observer = new MutationObserver((mutations) => {
      const currentDiscountEstimate = productSection.querySelector('.discount-estimate');
      if (currentDiscountEstimate) {
        const currentVariantId = currentDiscountEstimate.getAttribute('data-variant-id');
        
        if (currentVariantId && currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          this.updateVariantId();
          
          this.$nextTick(() => {
            this.updateUIOneTimePrice();
          });
        }
      }
    });
    observer.observe(discountEstimateContainer, {
      attributes: true,
      attributeFilter: ['data-variant-id']
    });

    const discountEstimateParent = discountEstimateContainer.parentElement;
    if (discountEstimateParent) {
      observer.observe(discountEstimateParent, {
        childList: true,
        subtree: true
      });
    }
    
    this.discountEstimateObserver = observer;
  },
  
  destroy() {
    if (this.discountEstimateObserver) {
      this.discountEstimateObserver.disconnect();
    }
  },

  updateVariantId() {
    this.variantId = this.$el.getAttribute('data-product-variant-id') 
      || window.dsc?.product?.variants?.[0]?.id?.toString();
  },

  updateUIOneTimePrice() {
    // Get the latest variant ID from the element's data attribute
    const currentVariantId = this.$el.getAttribute('data-product-variant-id');
    if (!currentVariantId) {
      return;
    }
    
    const productSection = this.$el.closest('[id^="MainProduct-"], [id^="shopify-section-"]') || document;
    const priceContainer = productSection.querySelector(
      `.discount-estimate[data-variant-id="${currentVariantId}"] .price-container[data-one-time-price]`
    );
    
    if (priceContainer?.dataset?.oneTimePrice) {
      this.oneTimePrice = priceContainer.dataset.oneTimePrice;
    } else {
      this.oneTimePrice = null;
    }
  },
  
  updateAddToAccountRestriction() {
    if(this.$el.dataset.hideAddToAccount == 'true') {
      window.dsc.hideAddToAccount = true;
      this.hideAddToAccount = true;
    }
  },
  
  handleFrequencyChange(event) {
    event.preventDefault();
    event.stopPropagation();

    const isUserWithSubscription = false; // This will be set properly by initializeOGAuth
    
    setPurchaseOptionState({
      state: 'subscribe',
      checkRadioButton: true,
      sellingPlanId: event.target.value,
      isUserWithSubscription
    });
  }
})

async function toggleInNextBoxMessageText(nextOrder, justAdded, isSubscription) {
  const context =  document.documentElement.classList.contains('quickview-open') ? document.querySelector('.quickview-content') : document;

  const productInfo = context.querySelector('.dsc-custom-ordergroove-ui') || context.querySelector('.legacy-dsc-custom-ordergroove-ui')

  if (!productInfo) {
    return false;
  }
  
  const ogNextOrder = await getOGOrder(nextOrder.public_id)
  const productsInNextOrder = ogNextOrder.results.reduce(
    (result, { product }) => {
      result[product] = true
      return result
    },
    {},
  )
  const productId = productInfo.getAttribute('data-product-variant-id')
  const subscribeRadioButton = context.querySelector('.subscribe-radio-button')
  const addOneTimeToNextBoxRadioButton = context.querySelector('.add-one-time-to-next-box-radio-button')
  const productInNextBoxMessage = context.querySelector('.in-next-box-message')
  const nextBoxShips = context.querySelector('.next-box-ships')
  const productInNextBoxMessageText = context.querySelector(
    '.in-next-box-message-text',
  )
  const nextBoxDate = context.querySelector('.next-box-date')
  const productInNextBoxTitle = context.querySelector(
    '.in-next-box-message p:first-child',
  )

  const userLocale = new Intl.NumberFormat().resolvedOptions().locale
  const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(
    userLocale,
    { month: 'short', day: 'numeric' },
  )
  
  // Replace date placeholder in any text
  const originalHTML = productInNextBoxMessageText.innerHTML
  productInNextBoxMessageText.innerHTML = originalHTML.replace('{date}', `${nextOrderDate}`)
  if (nextBoxDate) {
    nextBoxDate.textContent = nextOrderDate
  } else {
    nextBoxShips.innerHTML = nextBoxShips.innerHTML.replace('{date}', `<span class="font-medium">${nextOrderDate}</span>`)
  }
  
  // check if product is in next order
  // show message if product is in next order
  if (productsInNextOrder[productId]) {
    addOneTimeToNextBoxRadioButton.classList.add('hidden')
    subscribeRadioButton.classList.add('hidden')
    productInNextBoxMessage.classList.remove('hidden')
    
    // If the product was just added, show a different message
    if (justAdded) {
      const checkmarkSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
        <rect x="0.5" width="16" height="16" rx="8" fill="currentColor"/>
        <path d="M12.0645 4.27767C10.5448 4.72273 8.73396 6.98726 6.99824 9.3129C6.26159 8.13715 5.48119 7.74457 4.67428 8.14681C4.57468 8.19639 4.50907 8.29147 4.50086 8.39839C4.49265 8.50641 4.54382 8.61075 4.63639 8.67475C5.22149 9.07949 5.82847 9.79689 6.55029 10.9327V10.9323C6.67919 11.1384 6.91354 11.2642 7.16585 11.2627H7.17757C7.4377 11.2605 7.67596 11.1258 7.80211 10.9105C8.50438 9.70442 9.27576 8.53606 10.1128 7.41022C10.7986 6.48679 11.5634 5.61772 12.3992 4.81229C12.5117 4.70796 12.5324 4.5437 12.4492 4.41717C12.3715 4.29101 12.2114 4.23291 12.0645 4.27767Z" fill="white"/>      </svg>`;
      
      // Use the isSubscription parameter to determine the message
      if (isSubscription) {
        productInNextBoxTitle.innerHTML = `${checkmarkSvg} ${window.dsc.inYourNextBoxTitleSubscription}`;
      } else {
        productInNextBoxTitle.innerHTML = `${checkmarkSvg} ${window.dsc.addedToNextBox}`;
      }
    }
    
    setPurchaseOptionState({
      state: 'ship-now',
      checkRadioButton: true
    })
    return true
  } else {
    addOneTimeToNextBoxRadioButton.classList.remove('hidden')
    subscribeRadioButton.classList.remove('hidden')
    productInNextBoxMessage.classList.add('hidden')
    return false
  }
}

window.dsc.toggleInNextBoxMessageTextPDP = toggleInNextBoxMessageText

function showModalOptions(option, context) {
  try {
    
      context = context || document;
      const purchaseOptions = context.querySelector('.dsc-custom-ordergroove-ui-options');
      const inNextBoxMessage = context.querySelector('.in-next-box-message');
      const nextBoxRadioButton = context.querySelector('.add-one-time-to-next-box-radio-button');
      const loadingSkeleton = context.querySelector('.dsc-ordergroove-loading');
      const subscriberOptions = context.querySelector('.subscriber-options');
      const notSubscriberOptions = context.querySelector('.not-subscriber-options');
      let atcButton;
      
     
      
      // Only return early if we don't have the essential elements (purchaseOptions)
      if (!purchaseOptions) {
        return;
      }

      switch (option) {
        case 'not-a-subscriber':
          inNextBoxMessage?.classList.add('hidden');
          nextBoxRadioButton?.classList.add('hidden');
          break;
        default:
          break;
      }
      
      if (loadingSkeleton) {
        loadingSkeleton.classList.add('hidden');
        
        // Force a DOM reflow to ensure the hidden class takes effect
        void loadingSkeleton.offsetWidth;
      }
      if (purchaseOptions) {
        purchaseOptions.classList.remove('hidden');
      }
      
      atcButton = document.querySelector('product-form .product-form__submit');
      if(document.documentElement.classList.contains('quickview-open')) {
        atcButton = context.querySelector('.quickview-add-to-cart-form button[type="submit"]');
      }
      atcButton?.removeAttribute('disabled');
      document.querySelector('.dsc-custom-ordergroove-ui-quickview')?.classList.remove('loading');
    } 
    catch(error) {
      document.querySelector('.dsc-custom-ordergroove-ui-quickview')?.classList.remove('loading');
    }
}

function createHiddenInput({ id, name, value }) {
  const hiddenInput = document.createElement('input')
  hiddenInput.id = id
  hiddenInput.type = 'hidden'
  hiddenInput.name = name
  hiddenInput.value = value
  return hiddenInput
}

function findATCForm() {
  // Try to find the main product form first, then quickview form
  let addToCartForm = document.querySelector('form[data-type="add-to-cart-form"]')
  if (!addToCartForm) {
    addToCartForm = document.querySelector('.quickview-add-to-cart-form')
  }
  if (!addToCartForm) {
    addToCartForm = document.querySelector('form[action="/cart/add"]')
  }
  if (!addToCartForm) {
    return false
  }
  else {
    return addToCartForm;
  }
}

function addSellingPlanIdToAddCartForm(sellingPlanId) {
  if (document.querySelector('#selling-plan-id')) {
    updateSellingPlanIdOnAddCartForm(sellingPlanId)
    return
  }

  let addToCartForm = findATCForm();
  if(!addToCartForm) return;
    
  const sellingPlanInput = createHiddenInput({
    id: 'selling-plan-id',
    name: 'selling_plan',
    value: sellingPlanId,
  })
  addToCartForm.append(sellingPlanInput)
}

function removeSellingPlanIdFromAddCartForm() {
  const sellingPlanInput = document.querySelector('#selling-plan-id')
  if (sellingPlanInput) {
    sellingPlanInput.remove()
  }
}

function updateSellingPlanIdOnAddCartForm(sellingPlanId) {
  const sellingPlanInput = document.querySelector('#selling-plan-id')
  if (sellingPlanInput) {
    sellingPlanInput.value = sellingPlanId
  }
}

function addAddToNextBoxToAddCartForm() {
  
  let addToCartForm = findATCForm();
  if(!addToCartForm) return;
  
  if (document.querySelector('#add-to-next-box')) return;

  // add add-to-next-box hidden input
  const addToNextBoxInput = createHiddenInput({
    id: 'add-to-next-box',
    name: 'add_to_next_box',
    value: 'add_to_next_box',
  });
  addToCartForm.append(addToNextBoxInput)

  // add price to form
  const productInfo = document.querySelector('.dsc-custom-ordergroove-ui')
  
  // Add null check to prevent errors in quickview modal context
  if (!productInfo) {
    return;
  }
  
  const productVariantPrice = productInfo.getAttribute('data-product-variant-price')
  const productVariantPriceInput = createHiddenInput({
    id: 'product-variant-price',
    name: 'price',
    value: productVariantPrice,
  });
  addToCartForm.append(productVariantPriceInput)
}

function removeAddToNextBoxFromAddCartForm() {
  const addToNextBoxInput = document.querySelector('#add-to-next-box')
  const productVariantPriceInput = document.querySelector('#product-variant-price')
  if (addToNextBoxInput) {
    addToNextBoxInput.remove()
  }
  if (productVariantPriceInput) {
    productVariantPriceInput.remove()
  }
}

function setupListeners(isUserWithSubscription) {
  const context =  document.documentElement.classList.contains('quickview-open') ? document.querySelector('.quickview-content') : document;
  const subscriptionFrequency = context.querySelector('#subscription-frequency');
  const subscribeRadioButton = context.querySelector('#subscribe-radio-button');
  const shipNowRadioButton = context.querySelector('#ship-now-subscriber');
  const addToNextBoxRadioButton = context.querySelector('#add-one-time-to-next-box-subscriber');
  
    if (subscribeRadioButton) {
    subscribeRadioButton.addEventListener('click', () => {
      setPurchaseOptionState({
        state: 'subscribe',
        checkRadioButton: true,
        sellingPlanId: subscriptionFrequency ? subscriptionFrequency.value : null,
        isUserWithSubscription
      });
    });
  }

  if (subscriptionFrequency) {
    subscriptionFrequency.addEventListener('change', (event) => {
      event.preventDefault();
      event.stopPropagation();

      setPurchaseOptionState({
        state: 'subscribe',
        checkRadioButton: true,
        sellingPlanId: event.target.value,
        isUserWithSubscription
      });
    });
  }

  if (shipNowRadioButton) {
    shipNowRadioButton.addEventListener('click', () => {
      setPurchaseOptionState({
        state: 'ship-now',
        checkRadioButton: true,
        isUserWithSubscription
      });
    });
  }

  if (addToNextBoxRadioButton) {
    addToNextBoxRadioButton.addEventListener('click', () => {
      setPurchaseOptionState({
        state: 'add-to-next-box',
        checkRadioButton: true,
        isUserWithSubscription
      })
    });
  }
}

function setPurchaseOptionState({ state, checkRadioButton, sellingPlanId, isUserWithSubscription}) {
  const context =  document.documentElement.classList.contains('quickview-open') ? document.querySelector('.quickview-content') : document;

  if (window.dsc?.hideAddToAccount && state === 'add-to-next-box') {
    state = 'ship-now';
    checkRadioButton = true;
  }

  const allRadioButtons = context.querySelectorAll('input[type="radio"][name="dsc-custom-ordergroove-ui"]');
  const allOptionContainers = context.querySelectorAll('.option-container');
  
  allRadioButtons.forEach(radio => radio.checked = false);
  allOptionContainers.forEach(container => container.classList.remove('radio-checked'));

  switch (state) {
    case 'subscribe':
      if (checkRadioButton) {
        const subscribeRadioButton = context.querySelector('#subscribe-radio-button');
        
        const subscribeContainer = context.querySelector('.subscribe-radio-button');
        
        if (subscribeRadioButton) {
          subscribeRadioButton.checked = true;
        }
        if (subscribeContainer) {
          subscribeContainer.classList.add('radio-checked');
        }
      }

      if (isUserWithSubscription) {
        addAddToNextBoxToAddCartForm();
        if(!window.dsc?.hideAddToAccount) {
          changeAddToCartButtonText('Add to subscription');
        } else {
          changeAddToCartButtonText(window.dsc.addToCartText);
        }
      } else {
        removeAddToNextBoxFromAddCartForm();
        changeAddToCartButtonText(window.dsc.addToCartText);
      }
      
      addSellingPlanIdToAddCartForm(sellingPlanId);
      break;
    case 'add-to-next-box':
      if (checkRadioButton) {
        const addToNextBoxRadioButton = context.querySelector('#add-one-time-to-next-box-subscriber');
        
        const addToNextBoxContainer = context.querySelector('.add-one-time-to-next-box-radio-button');
        
       if (addToNextBoxRadioButton) {
          addToNextBoxRadioButton.checked = true;
        }
        if (addToNextBoxContainer) {
          addToNextBoxContainer.classList.add('radio-checked');
        }
      }
      removeSellingPlanIdFromAddCartForm();

      if (isUserWithSubscription && !window.dsc?.hideAddToAccount) {
        changeAddToCartButtonText(window.dsc.addToNextBoxText);
      } else {
        changeAddToCartButtonText(window.dsc.addToCartText);
      }

      addAddToNextBoxToAddCartForm();
      break;
    case 'ship-now':
      if (checkRadioButton) {
        const shipNowRadioButton = context.querySelector('#ship-now-subscriber');
        
        const shipNowContainer = shipNowRadioButton ? shipNowRadioButton.closest('.option-container') : null;
        
        if (shipNowRadioButton) {
          shipNowRadioButton.checked = true;
        }
        if (shipNowContainer) {
          shipNowContainer.classList.add('radio-checked');
        }
      }

      changeAddToCartButtonText(window.dsc.addToCartText);
      removeAddToNextBoxFromAddCartForm();
      removeSellingPlanIdFromAddCartForm();
      break;
    default:
      break;
  }
}

function getDefaultPurchaseOptionQueryParam() {
  const searchUrlParams = new URLSearchParams(window.location.search);
  const defaultPurchaseOptionQueryParam = searchUrlParams.get('defaultPurchaseOption');
  switch (defaultPurchaseOptionQueryParam) {
    case 'shipNow':
      return 'ship-now'
    case 'subscription':
      return 'subscribe'
    default:
      return ''
  }
}

function setDefaultPurchaseOption({ isProductSubscribeable, isUserWithSubscription }, passedProductInfo) {
  const context = document.documentElement.classList.contains('quickview-open') ? document.querySelector('.quickview-content') : document;
  
  const defaultPurchaseOptionQueryParam = getDefaultPurchaseOptionQueryParam();
  const productInfo = passedProductInfo || context.querySelector('.dsc-custom-ordergroove-ui');
  // Early return if productInfo is null to prevent errors
  if (!productInfo) {
    return;
  }
  
  const defaultPurchaseOption = defaultPurchaseOptionQueryParam || productInfo.getAttribute('data-default-purchase-option');
  const subscriptionFrequency = document.querySelector('#subscription-frequency')
  
  switch (defaultPurchaseOption) {
    case 'subscribe': {
      if (isProductSubscribeable) {
        setPurchaseOptionState({
          state: 'subscribe',
          checkRadioButton: true,
          isUserWithSubscription,
          sellingPlanId: subscriptionFrequency.value
        });
      } else {
        if (isUserWithSubscription) {
          setPurchaseOptionState({
            state: 'add-to-next-box',
            checkRadioButton: true,
            isUserWithSubscription
          });
        } else {
          setPurchaseOptionState({
            state: 'ship-now',
            checkRadioButton: true,
            isUserWithSubscription
          });
        }
      }
      break;
    }
    
    case 'add-to-next-box': {
      setPurchaseOptionState({
        state: 'add-to-next-box',
        checkRadioButton: true,
        isUserWithSubscription
      });
      break;
    }
    
    case 'ship-now': {
      setPurchaseOptionState({
        state: 'ship-now',
        checkRadioButton: true,
        isUserWithSubscription
      });
      break;
    }

    default: {
      if (isProductSubscribeable) {
        setPurchaseOptionState({
          state: 'subscribe',
          checkRadioButton: true,
          isUserWithSubscription,
          sellingPlanId: subscriptionFrequency?.value || null
        });
      } else {
        if (isUserWithSubscription) {
          setPurchaseOptionState({
            state: 'add-to-next-box',
            checkRadioButton: true,
            isUserWithSubscription
          });
        } else {
          setPurchaseOptionState({
            state: 'ship-now',
            checkRadioButton: true
          });
        }
      }
      break;
    }
    
  }
}

function changeAddToCartButtonText(text) {
  // Try to find product form in main page context
  const context = document.documentElement.classList.contains('quickview-open') ? document.querySelector('.quickview-content') : document;
  let productForm = context.querySelector('form')
  let addToCartButton = null
  
  if (productForm) {
    addToCartButton = productForm.querySelector('.atc-text') ?? productForm.querySelector('.button-content')
  }
  
  addToCartButton = context.querySelector('.atc-text') ?? 
                     context.querySelector('.button-content') ??
                     context.querySelector('button[type="submit"]')
  
  if (addToCartButton) {
    addToCartButton.innerHTML = text ?? 'Add To Cart'
  } else {
    console.warn('Could not find Add to Cart button text element - skipping text change')
  }
}

async function initializeOGAuth() {
  const context = document.documentElement.classList.contains('quickview-open')
    ? document.querySelector('.quickview-content')
    : document;

  await window.dsc?.ensureSubscriberHydrated?.();

  const ogCustomer = await getOGCustomer(window?.dsc?.customerId);

  const ogUpcomingOrders = await getOGUpcomingOrders(window?.dsc?.customerId);

  if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
    sortOGOrders(ogUpcomingOrders.results);
  }

  const isUserWithSubscription = !!(ogCustomer && ogUpcomingOrders && ogUpcomingOrders.count > 0);
  window.dsc.isUserWithSubscription = isUserWithSubscription;

  if (window?.dsc?.customerId && window?.dsc?.customerId !== 'null') {
    try {
      const subscriptions = await getOGSubscriptions(window.dsc.customerId);
      let activeSubscriptionsCount = 0;

      if (subscriptions && Array.isArray(subscriptions.results)) {
        const activeSubscriptions = subscriptions.results.filter((sub) => sub.live === true);
        activeSubscriptionsCount = activeSubscriptions.length;
      }

      window.dsc.activeSubscriptionsCount = activeSubscriptionsCount;
    } catch (error) {
      console.warn('Failed to fetch subscriptions for Club Benefits:', error);
      window.dsc.activeSubscriptionsCount = 0;
    }
  }

  const productInfo = context.querySelector('.dsc-custom-ordergroove-ui');

  if (!productInfo) {
    window.dsc.clubBenefitsLoaded = true;
    document.dispatchEvent(
      new CustomEvent('club-benefits-data-ready', {
        detail: {
          activeSubscriptionsCount: window.dsc.activeSubscriptionsCount || 0,
          clubBenefitsSubActionTaken: window.dsc.clubBenefitsSubActionTaken ?? false,
        },
      }),
    );
    document.dispatchEvent(new CustomEvent('ordergroove-initialized'));
    return;
  }

  const numberOfSellingPlans = productInfo.getAttribute('data-number-of-selling-plans');

  setupListeners(isUserWithSubscription, productInfo);

  if (isUserWithSubscription) {
    let isInNextBox = false;
    if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
      isInNextBox = await toggleInNextBoxMessageText(ogUpcomingOrders.results[0]);
    }

    if (!isInNextBox) {
      if (numberOfSellingPlans === '0') {
        const subscriptionOptionContainer = context.querySelector('.subscribe-radio-button.option-container');
        if (subscriptionOptionContainer) {
          subscriptionOptionContainer.classList.add('hidden');
        }

        setDefaultPurchaseOption(
          {
            isProductSubscribeable: false,
            isUserWithSubscription,
          },
          productInfo,
        );
      } else {
        setDefaultPurchaseOption(
          {
            isProductSubscribeable: true,
            isUserWithSubscription,
          },
          productInfo,
        );
      }
    }

    showModalOptions('subscriber', context);
  } else {
    if (numberOfSellingPlans === '0') {
      productInfo.remove();
      setDefaultPurchaseOption(
        {
          isProductSubscribeable: false,
          isUserWithSubscription,
        },
        productInfo,
      );
    } else {
      setDefaultPurchaseOption(
        {
          isProductSubscribeable: true,
          isUserWithSubscription,
        },
        productInfo,
      );
    }

    showModalOptions('not-a-subscriber', context);
  }

  window.dsc.clubBenefitsLoaded = true;
  document.dispatchEvent(
    new CustomEvent('club-benefits-data-ready', {
      detail: {
        activeSubscriptionsCount: window.dsc.activeSubscriptionsCount || 0,
        clubBenefitsSubActionTaken: window.dsc.clubBenefitsSubActionTaken ?? false,
      },
    }),
  );

  document.dispatchEvent(new CustomEvent('ordergroove-initialized'));
}

window.dsc = window.dsc || {};
window.dsc.lastAddedVariant = null;

document.addEventListener('ordergroove-initialized', () => {
  const pdpAddButton = document.querySelector('product-form button[type="submit"]');
  
    const productForm = document.querySelector('product-form');
  if (productForm) {
    productForm.addEventListener('variant:change', () => {
      window.dsc.lastAddedVariant = null;
    });
  }

  if (pdpAddButton) {
    const atcForm = document.querySelector('form[data-type="add-to-cart-form"]');

    pdpAddButton.addEventListener('click', () => {
      // Skip if quickview is open - quickview-switcher handles its own events.
      if (document.documentElement.classList.contains('quickview-open')) {
        return;
      }

      const variantId = Number(atcForm.querySelector('input.product-variant-id').value);
      const variantSku = atcForm.querySelector('input.product-variant-sku').value;
      const pdpRadioSelectedEl = document.querySelector('label.radio-checked');
      
      const quantityAdded = document.querySelector('input[name="quantity"]').value;
      if(!pdpRadioSelectedEl) {
        return;
      }
      const selectedRadioValue = pdpRadioSelectedEl.querySelector('input').value;
      const customerId = window.dsc?.customerId;

      // Only fire next box dl event for next-box or subscribe if user has a subscription
      if(customerId && window.dsc.isUserWithSubscription) {
        if(selectedRadioValue) {
          const quantityAdded = document.querySelector('input[name="quantity"]')?.value || 1;
          if (selectedRadioValue.includes('add-one-time-to-next-box')) {
            // Check if this variant was already added to prevent duplicate events
            if (window.dsc.lastAddedVariant !== variantId) {
              window.dsc.lastAddedVariant = variantId;
              window.dsc.fireDlAddToNextBoxEvent(
                'add-one-time-to-next-box',
                variantId,
                variantSku,
                quantityAdded,
                null,
                window.dsc.product
              );
            }
            return;
          } 
          else if (selectedRadioValue == 'add-to-next-box' || selectedRadioValue == 'subscribe') {
            let sellingPlanId = document.querySelector('input[name="selling_plan"]')?.value || null;
            sellingPlanId = Number(sellingPlanId) || 0;
            
            // Check if this variant was already added to prevent duplicate events
            if (window.dsc.lastAddedVariant !== variantId) {
              window.dsc.lastAddedVariant = variantId;
              window.dsc.fireDlAddToNextBoxEvent(
                'subscribe',
                variantId,
                variantSku,
                quantityAdded,
                sellingPlanId,
                window.dsc.product
              );
            }
            return;
          }
        }
        // For one-time purchases and customers with no active subscriptions, let the regular add to cart event handle it
      }
    });
  }
})